import React, { useState } from 'react';
import css from './Sections.module.css';
import classNames from 'classnames';
import { createResourceLocatorString } from '../../../util/routes';
import Icons from '../../../components/Icons/Icons';

const STEPS_OPTIONS = [
  [
    {
      key: 'mental',
      icon: <Icons name="brain" />,
      titleId: 'CustomWelcomePage.Welcome.optionMentalWellness.title',
      descId: 'CustomWelcomePage.Welcome.optionMentalWellness.description',
    },
    {
      key: 'sleep',
      icon: <Icons name="bed" />,
      titleId: 'CustomWelcomePage.Welcome.optionSleepFatigue.title',
      descId: 'CustomWelcomePage.Welcome.optionSleepFatigue.description',
    },
    {
      key: 'hotFlashes',
      icon: <Icons name="fire" />,
      titleId: 'CustomWelcomePage.Welcome.optionHotFlashes.title',
      descId: 'CustomWelcomePage.Welcome.optionHotFlashes.description',
    },
    {
      key: 'nutrition',
      icon: <Icons name="nutritionWeight" />,
      titleId: 'CustomWelcomePage.Welcome.optionNutrition.title',
      descId: 'CustomWelcomePage.Welcome.optionNutrition.description',
    },
    {
      key: 'sexual',
      icon: <Icons name="sexual" />,
      titleId: 'CustomWelcomePage.Welcome.optionSexual.title',
      descId: 'CustomWelcomePage.Welcome.optionSexual.description',
    },
    {
      key: 'medical',
      icon: <Icons name="medical" />,
      titleId: 'CustomWelcomePage.Welcome.optionMedical.title',
      descId: 'CustomWelcomePage.Welcome.optionMedical.description',
    },
  ],
  [
    {
      key: 'payment',
      icon: <Icons name="paymentMethod" />,
      titleId: 'CustomWelcomePage.Welcome.optionPayment.title',
      descId: 'CustomWelcomePage.Welcome.optionPayment.description',
    },
    {
      key: 'coupon',
      icon: <Icons name="coupon" />,
      titleId: 'CustomWelcomePage.Welcome.optionCoupon.title',
      descId: 'CustomWelcomePage.Welcome.optionCoupon.description',
    },
    {
      key: 'notifications',
      icon: <Icons name="bell" />,
      titleId: 'CustomWelcomePage.Welcome.optionNotifications.title',
      descId: 'CustomWelcomePage.Welcome.optionNotifications.description',
    },
    {
      key: 'schedule',
      icon: <Icons name="clock" />,
      titleId: 'CustomWelcomePage.Welcome.optionSchedule.title',
      descId: 'CustomWelcomePage.Welcome.optionSchedule.description',
    },
    {
      key: 'profile',
      icon: <Icons name="userInfo" />,
      titleId: 'CustomWelcomePage.Welcome.optionProfile.title',
      descId: 'CustomWelcomePage.Welcome.optionProfile.description',
    },
    {
      key: 'stats',
      icon: <Icons name="stats" />,
      titleId: 'CustomWelcomePage.Welcome.optionStats.title',
      descId: 'CustomWelcomePage.Welcome.optionStats.description',
    },
  ],
  [
    {
      key: 'goals',
      icon: <Icons name="goal" />,
      titleId: 'CustomWelcomePage.Welcome.optionGoals.title',
      descId: 'CustomWelcomePage.Welcome.optionGoals.description',
    },
    {
      key: 'habits',
      icon: <Icons name="cogs" />,
      titleId: 'CustomWelcomePage.Welcome.optionHabits.title',
      descId: 'CustomWelcomePage.Welcome.optionHabits.description',
    },
    {
      key: 'resources',
      icon: <Icons name="enveople" />,
      titleId: 'CustomWelcomePage.Welcome.optionResources.title',
      descId: 'CustomWelcomePage.Welcome.optionResources.description',
    },
    {
      key: 'reminders',
      icon: <Icons name="userCheck" />,
      titleId: 'CustomWelcomePage.Welcome.optionReminders.title',
      descId: 'CustomWelcomePage.Welcome.optionReminders.description',
    },
    {
      key: 'community',
      icon: <Icons name="community" />,
      titleId: 'CustomWelcomePage.Welcome.optionCommunity.title',
      descId: 'CustomWelcomePage.Welcome.optionCommunity.description',
    },
    {
      key: 'support',
      icon: <Icons name="support" />,
      titleId: 'CustomWelcomePage.Welcome.optionSupport.title',
      descId: 'CustomWelcomePage.Welcome.optionSupport.description',
    },
  ],
  [
    {
      key: 'summary',
      icon: <Icons name="summary" />,
      titleId: 'CustomWelcomePage.Welcome.optionSummary.title',
      descId: 'CustomWelcomePage.Welcome.optionSummary.description',
    },
    {
      key: 'review',
      icon: <Icons name="review" />,
      titleId: 'CustomWelcomePage.Welcome.optionReview.title',
      descId: 'CustomWelcomePage.Welcome.optionReview.description',
    },
    {
      key: 'finish',
      icon: <Icons name="finish" />,
      titleId: 'CustomWelcomePage.Welcome.optionFinish.title',
      descId: 'CustomWelcomePage.Welcome.optionFinish.description',
    },
    {
      key: 'dashboard',
      icon: <Icons name="dashboard" />,
      titleId: 'CustomWelcomePage.Welcome.optionDashboard.title',
      descId: 'CustomWelcomePage.Welcome.optionDashboard.description',
    },
    {
      key: 'tutorial',
      icon: <Icons name="tutorial" />,
      titleId: 'CustomWelcomePage.Welcome.optionTutorial.title',
      descId: 'CustomWelcomePage.Welcome.optionTutorial.description',
    },
    {
      key: 'contact',
      icon: <Icons name="contact" />,
      titleId: 'CustomWelcomePage.Welcome.optionContact.title',
      descId: 'CustomWelcomePage.Welcome.optionContact.description',
    },
  ],
];

export default function WelcomeSection(props) {
  const { intl, history, routeConfiguration } = props;

  const [currentStep, setCurrentStep] = useState(0);
  const [selections, setSelections] = useState({});

  const options = STEPS_OPTIONS[currentStep];

  const handleSelect = key => {
    setSelections({ ...selections, [currentStep]: key });
  };

  const handleNext = () => {
    if (currentStep < STEPS_OPTIONS.length - 1) {
      setCurrentStep(currentStep + 1);
    } else {
      history.push(createResourceLocatorString('LandingPage', routeConfiguration, {}, {}));
    }
  };

  const handleBack = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  return (
    <div className={css.container}>
      <div className={css.leftPane}>
        <div className={css.leftpaneinner}>
          <h1 className={css.heading}>
            {intl.formatMessage({ id: 'CustomWelcomePage.Welcome.heading' })}
          </h1>

          <div className={css.grid}>
            {options.map(opt => {
              const isActive = selections[currentStep] === opt.key;
              return (
                <button
                  key={opt.key}
                  className={classNames(css.card, { [css.active]: isActive })}
                  onClick={() => handleSelect(opt.key)}
                >
                  <div className={css.iconWrapper}>{opt.icon}</div>
                  {isActive && <span className={css.checkMark}>✓</span>}
                  <h2 className={css.title}>{intl.formatMessage({ id: opt.titleId })}</h2>
                  <p className={css.description}>{intl.formatMessage({ id: opt.descId })}</p>
                </button>
              );
            })}
          </div>

          <div className={css.footerNav}>
            <div className={css.progress}>
              {STEPS_OPTIONS.map((_, i) => (
                <span
                  key={i}
                  className={classNames(css.dot, { [css.activeDot]: i === currentStep })}
                />
              ))}
            </div>

            <div className={css.actions}>
              <button className={css.backBtn} onClick={handleBack} disabled={currentStep === 0}>
                <Icons name="leftArrow" />{' '}
                {intl.formatMessage({ id: 'CustomWelcomePage.Welcome.back' })}
              </button>

              <button className={css.continueBtn} onClick={handleNext}>
                {currentStep === STEPS_OPTIONS.length - 1
                  ? intl.formatMessage({ id: 'CustomWelcomePage.Welcome.finish' })
                  : intl.formatMessage({ id: 'CustomWelcomePage.Welcome.continue' })}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className={css.rightPane}>{/* background image via CSS */}</div>
    </div>
  );
}
